import { FC, ImgHTMLAttributes, useEffect, useState } from 'react';

import SkeletonItem from 'components/skeleton/SkeletonItem';

import classNames from 'classnames';

export interface SkeletonImageProps {
  skeletonClassNames?: string;
  animated?: boolean;
}

const SkeletonImage: FC<SkeletonImageProps & ImgHTMLAttributes<HTMLImageElement>> = ({
  skeletonClassNames,
  animated = true,
  ...props
}) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const [imgSrc, setImgSrc] = useState(props.src);

  useEffect(() => {
    if (imgSrc !== props.src) {
      setImgLoaded(false);
      setImgSrc(props.src);
    }
  }, [imgSrc, props.src]);

  return (
    <>
      {!imgLoaded && <SkeletonItem classNames={skeletonClassNames} rounded="md" animated={animated} />}
      <div className="tw-bg-raa-gray-3">
        <img
          src={imgSrc}
          alt={props.alt}
          className={classNames(props.className, { 'tw-animate-fade-in': imgLoaded, 'tw-hidden': !imgLoaded })}
          onLoad={() => setImgLoaded(true)}
        />
      </div>
    </>
  );
};

export default SkeletonImage;
